var Marionette = require('backbone.marionette');
var Header = require('./views/layout/header');
var Body = require('./views/layout/body');
var Footer = require('./views/layout/footer');
var SvnInfoModal = require('./views/system/svn-info-modal');
var ActiveSessionsModal = require('./views/system/active-sessions-modal');

var SessionModel = require('./models/session-model');

var Radio = require('backbone.radio');
var servicesChannel = Radio.channel('services');
var actionsChannel = Radio.channel('actions');

var servicesAddresses = undefined;
var defaultMedicationForms = undefined;

var Controller = Marionette.View.extend({

    template: _.template('<div id="app-header" class="app-header"></div><div id="app-body"></div><div id="system-modal"></div><div id="app-footer"></div>'),

    adminMenuItems: [
        {title: 'Settings', url: '#settings', activeClass: ''}
    ],

    currentSessionId: undefined,

    regions: {
        header: '#app-header',
        body: '#app-body',
        footer: '#app-footer',
        systemModal: "#system-modal"
    },

    notAuthenticablePaths: ['login', 'signup', 'help', 'help-physician', 'help-office-admin', 'help-corporate-admin', 'help-feedback', 'login/by-instant-token/:token'],
    adminOnlyPaths: ['settings', 'relations', 'persons', 'person/:entry', 'relationtypes', 'relationtype/:entry', 'roles',
        'doctypes', 'import-persons', 'merge-persons'],
    session: new SessionModel(),

    childViewEvents: {
        'invalidate:current:session:id': 'invalidateCurrentSessionId'
    },

    initOnceSingletonData: function () {
        this.fetchAndSetServicesAddresses();
        this.fetchAndSetDefaultMedicationForms();
    },

    getServicesAddresses: function () {
        return servicesAddresses;
    },

    getDefaultMedicationForms: function () {
        return defaultMedicationForms;
    },

    fetchAndSetServicesAddresses: function () {
        if (servicesAddresses == undefined) {
            $.ajax({
                type: "GET",
                url: '/api/reference/hosts',
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        servicesAddresses = response;
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });
        }
    },

    fetchAndSetDefaultMedicationForms: function () {
        if (defaultMedicationForms == undefined) {
            $.when(
                $.ajax({
                    type: "GET",
                    headers: {
                        Accept: 'application/json'
                    },
                    url: 'https://rxnav.nlm.nih.gov/REST/allconcepts.json?tty=DFG',
                })
            ).done(function (resp) {
                defaultMedicationForms = _.sortBy(resp.minConceptGroup.minConcept.map(function (concept) {
                    return {
                        id: concept.rxcui,
                        name: concept.name
                    }
                }), 'name');
            }).fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
            });
        }
    },


    initialize: function () {
        var that = this;
        that.options = {};
        this.defaultMenuItems = that.createDefaultMenuItems();
        servicesChannel.reply('get:services:address', that.getServicesAddresses);
        servicesChannel.reply('get:default:medication:forms', that.getDefaultMedicationForms);
        actionsChannel.reply('redirect:to:login', function () {
            that.getChildView('header').clearAndToMainPage();
        });

        that.initOnceSingletonData();
    },

    onRender: function () {
        var that = this;

        var body = new Body();
        var header = new Header({
            menuItems: _.map(that.defaultMenuItems, _.clone),
            defaultMenuItems: that.defaultMenuItems,
            body: body
        });

        this.getRegion('header').show(header);
        this.getRegion('body').show(body);

        var footer = new Footer();
        this.getRegion('footer').show(footer);

        /** We want easy access to our root view later */
        this.options.header = header;
        this.options.body = body;
        this.options.footer = footer;


        // fix for opening modal over other modals
        $(document).on('hidden.bs.modal', function (event) {
            if ($('.modal:visible').length) {
                $('body').addClass('modal-open');
            }
        });

        // init system and meta things
        this.initSystemAndMeta();
    },

    actionDispatch: function (bodyEvent, menuItem, entry, entry2) {
        if (this.notAuthenticablePaths.indexOf(menuItem) > -1) {
            this.actionDispatchRender(bodyEvent, menuItem, entry, entry2);
            return;
        }
        var that = this;
        this.session.fetch({
            error: function () {
                that.getChildView('header').clearAndToMainPage();
            },
            success: function (gotSession) {
                if ((gotSession.get('systemRoles') || []).indexOf('ADMIN') <= -1 && that.adminOnlyPaths.indexOf(menuItem) > -1
                    && !that.isUsersOwnProfile(bodyEvent, entry, gotSession) && bodyEvent != 'show:person:entry') {
                    Backbone.history.navigate('/', {trigger: true});
                } else if (gotSession.get('person').defaultPassword) {
                    that.updateSession(gotSession);
                    that.actionDispatchRender('change:password:entry', 'settings', gotSession.get('person').login);
                    Backbone.history.navigate('/', {trigger: false});
                } else {
                    that.updateSession(gotSession);
                    that.actionDispatchRender(bodyEvent, menuItem, entry, entry2);
                }
            }
        });
    },

    actionDispatchRender: function (bodyEvent, menuItem, entry, entry2) {
        var layout = this.options.body;
        if (typeof entry === 'undefined')
            layout.triggerMethod(bodyEvent);
        else if (typeof entry2 === 'undefined')
            layout.triggerMethod(bodyEvent, entry);
        else
            layout.triggerMethod(bodyEvent, entry, entry2);
        this.options.header.triggerMethod('menu:changed', menuItem);
    },

    updateSession: function (session) {
        if (this.currentSessionId && this.currentSessionId == session.get('id')) {
            return;
        }
        this.session = session;
        this.currentLogin = session.get('person').login;
        this.defaultMenuItems = this.createDefaultMenuItems();
        if ((session.get('systemRoles') || []).indexOf('ADMIN') > -1) {
            this.options.header.options.menuItems =
                _.union(this.defaultMenuItems, this.adminMenuItems);
        } else {
            this.options.header.options.menuItems = this.defaultMenuItems;
        }
        this.currentSessionId = session.get('id');
        this.options.header.triggerMethod('session:changed', session);
        this.options.body.triggerMethod('session:changed', session);
    },

    invalidateCurrentSessionId: function () {
        this.currentSessionId = undefined;
    },

    createDefaultMenuItems: function () {
        return [
            {
                title: 'Documents', url: '/#documents', activeClass: 'dropdown',
                submenus: [
                    {title: 'View All', url: '/#documents?object_type=pdf', activeClass: ''},
                    {title: 'Review Requested', url: '/#documents?toReview=true', activeClass: ''},
                    {
                        title: 'Reviewed by Me',
                        url: '/#documents?PERSON_REVIEW_FINISHED_REQUEST=' + (this.currentLogin || ''),
                        activeClass: ''
                    },
                    {title: 'Upload', url: '/#upload', activeClass: ''},
                    {title: 'Upload Signed Document', url: '/#upload-signed', activeClass: ''}
                ]
            },
            {title: 'Organizations', url: '/#organizations', activeClass: 'active'},
            {title: 'Patients', url: '/#patients', activeClass: ''},
            {title: 'Reports', url: '/#statistics', activeClass: ''},
            {
                title: 'Forms', url: '/#forms', activeClass: 'dropdown',
                submenus: [
                    {title: 'Village Podiatry HH Orders Form', url: '/#village-podiatry-form', activeClass: ''},
                    {title: 'Face-to-face Form', url: '/#ff-form', activeClass: ''},
                    {title: 'Face-to-face Forms List', url: '/#ff-forms', activeClass: ''}
                ]
            }
        ]
    },

    initSystemAndMeta: function () {
        var that = this;
        document.onkeyup = function (e) {

            if (that.currentSessionId) {
                if (e.ctrlKey && e.shiftKey && e.which == 49) { // for SVN info
                    var svnInfoModal = new SvnInfoModal();
                    that.getRegion('systemModal').show(svnInfoModal);
                } else if (e.ctrlKey && e.shiftKey && e.which == 50 && (that.session.get('systemRoles') || []).indexOf('ADMIN') > -1) { // Active Sessions (Users) only By Admin
                    var activeSessionsModal = new ActiveSessionsModal({mySessionId: that.currentSessionId});
                    that.getRegion('systemModal').show(activeSessionsModal);
                }
            }
        };
    },

    showRoot: function () {
        Backbone.history.navigate('/documents?object_type=pdf', {trigger: true});
    },
    organizationsList: function () {
        this.actionDispatch('show:organizations:list', 'organizations');
    },
    organizationEntry: function (entry) {
        this.actionDispatch('show:organization:entry', 'organizations', entry);
    },
    organizationEntryPatients: function (entry) {
        this.actionDispatch('show:organization:entry:patients', 'organizations', entry);
    },
    personEntry: function (entry) {
        this.actionDispatch('show:person:entry', 'settings', entry);
    },
    documentsList: function () {
        this.actionDispatch('show:documents:list', 'documents');
    },
    documentEntry: function (entry) {
        this.actionDispatch('show:document:entity', 'documents', entry);
    },
    documentHistoryEntry: function (entry) {
        this.actionDispatch('show:document:history:entity', 'documents', entry);
    },
    historyEntries: function (entry) {
        this.actionDispatch('show:history:entries', 'documents', entry);
    },
    documentUploadShow: function () {
        this.actionDispatch('show:document:upload', 'documents');
    },
    uploadSignedDocumentShow: function () {
        this.actionDispatch('show:document:upload:signed', 'documents');
    },
    personsList: function () {
        this.actionDispatch('show:persons:list', 'settings');
    },
    login: function () {
        this.actionDispatch('show:login', 'login');
    },
    signup: function () {
        this.actionDispatch('show:signup', 'login');
    },
    settingsList: function () {
        this.actionDispatch('show:settings:list', 'settings');
    },
    relationsList: function () {
        this.actionDispatch('show:relations:list', 'settings');
    },
    relationtypesList: function () {
        this.actionDispatch('show:relationtypes:list', 'settings');
    },
    relationtypeEntry: function (entry) {
        this.actionDispatch('show:relationtype:entry', 'settings', entry);
    },
    rolesList: function () {
        this.actionDispatch('show:roles:list', 'settings');
    },
    changePasswordEntry: function (entry) {
        this.actionDispatch('change:password:entry', 'settings', entry);

    },
    doctypesList: function () {
        this.actionDispatch('show:doctypes:list', 'settings');
    },

    helpSectionsList: function () {
        this.actionDispatch('show:help:list', 'help');
    },

    helpPhysician: function () {
        this.actionDispatch('show:help:physician', 'help');
    },

    helpOfficeAdmin: function () {
        this.actionDispatch('show:help:office:admin', 'help');
    },

    helpCorporateAdmin: function () {
        this.actionDispatch('show:help:corporate:admin', 'help');
    },

    helpFeedback: function () {
        this.actionDispatch('show:help:feedback', 'help');
    },


    isUsersOwnProfile: function (bodyEvent, entry, session) {
        return (bodyEvent == 'show:person:entry' || bodyEvent == 'change:password:entry') && (session.attributes.name || '') == entry;
    },

    patientsList: function () {
        this.actionDispatch('show:patients:list', 'patients');
    },

    statistics: function () {
        this.actionDispatch('show:statistics', 'statistics');
    },

    instantToken: function (token) {
        this.actionDispatch('auth:by:instant:token', 'login/by-instant-token/:token', token);
    },

    importPersons: function () {
        this.actionDispatch('show:import:persons', 'settings');
    },

    mergePersons: function (mergeTo, mergeFrom) {
        this.actionDispatch('show:merge:persons', 'settings', mergeTo, mergeFrom);
    },

    referralForm: function () {
        this.actionDispatch('show:referral:form', 'login');
    },

    villagePodiatryForm: function (entry) {
        this.actionDispatch('show:village:podiatry:form', 'forms', entry);
    },

    faceToFaceForm: function (entry) {
        this.actionDispatch('show:ff:form', 'forms', entry);
    },

    faceToFaceFormsList: function () {
        this.actionDispatch('show:forms:list', 'forms');
    }
});

module.exports = Controller;


//////////////////
// WEBPACK FOOTER
// ./app/controller.js
// module id = 185
// module chunks = 0